import { isNil } from 'ramda';
import * as yup from 'yup';

export const tasksCronJobsSchema = yup.object().shape({
  cron: yup
    .string()
    .default('')
    .transform((item) => (isNil(item) ? '' : item)),
  config: yup.object().shape({
    reportDefinitionId: yup
      .string()
      .default('')
      .transform((item) => (isNil(item) ? '' : item)),
    period: yup
      .string()
      .default(undefined)
      .transform((item) => (isNil(item) ? '' : item))
  })
});
